import {
  ActivityType,
  PumpSuspendReason,
  PumpSuspendState,
} from "@tandemdiabetes/sugarmate-api-react-client"

import { ModalBody } from "@tandemdiabetes/sugarmate-react-components"
import { EventModalHeader } from "../EventModalHeader"
import { PumpSuspendReasonDisplay } from "./PumpSuspendReasonDisplay"
import type { PumpSuspensionEventProps } from "./PumpSuspensionEventProps"

import { PumpSuspensionTime } from "./PumpSuspensionTime"
import styles from "src/styles/entryModal.module.scss"

const prefix = "components.event_modal.pump_suspension."

export function PumpSuspensionEventModal(props: PumpSuspensionEventProps) {
  const { userEvent } = props

  return (
    <>
      <EventModalHeader
        activityType={ActivityType.PumpSuspension}
        userEvent={userEvent}
        closeBtnId="pump-suspension-event-close-btn"
      />
      <ModalBody className={styles.modalBody}>
        <PumpSuspendReasonDisplay userEvent={userEvent} />
        <PumpSuspensionTime
          displayLabelKey={`${prefix}insulin_stopped_at`}
          displayTimeString={userEvent.started_at}
        />
        {userEvent.pump_suspension.state === PumpSuspendState.Completed &&
          userEvent.pump_suspension.suspend_reason !==
            PumpSuspendReason.PumpMalfunction && (
          <PumpSuspensionTime
            displayLabelKey={`${prefix}insulin_resumed_at`}
            displayTimeString={userEvent.ended_at}
          />
        )}
      </ModalBody>
    </>
  )
}
